module.exports = __webpack_public_path__ + "media/3.ed5b31f9.mp3";